const currenciesCollection = [["DKK", "DKK"]]

export default currenciesCollection
